import * as React from "react";
import { IParagraphPartnershipBrandsProps } from "./ParagraphPartnershipBrandsProps";
import { Container } from "./ParagraphPartnershipBrandsHelpers";
import { graphql } from "gatsby";
import PartnershipBrands from "../../common/PartnershipBrands/PartnershipBrands";

const ParagraphPartnershipBrands: React.FC<IParagraphPartnershipBrandsProps> = (
  props
) => {
  return (
    <Container>
      <PartnershipBrands {...props.node} />
    </Container>
  );
};
export const fragment = graphql`
  fragment ParagraphPartnershipBrands on paragraph__partnership_brands {
    id
    parent_type
    field_title
    field_description
    field_subtitle
    relationships {
      field_linked_logos {
        ... on paragraph__linked_logo {
          id
          field_link {
            url
            title
          }
          relationships {
            field_media {
              relationships {
                field_media_file {
                  publicUrl
                }
              }
            }
          }
        }
      }
    }
  }
`;
export default ParagraphPartnershipBrands;
